import { useQuery } from "react-query";

import http from "../../services/httpService";
import Util from "../../util/util";
import useUrls from "../useUrls";

export default function useQueryGetter(url, options = {}) {
  const { apiUrl } = useUrls();

  return useQuery(
    url,
    async () => {
      console.log(`useQueryGetter(${url}) called...`);

      const config = Util.addTokenToHeaders();
      const { data } = await http.get(`${apiUrl}${url}`, config);

      console.log(`useQueryGetter(${url}) response data:`);
      console.log(data);

      return data;
    },
    { enabled: true, refetchOnWindowFocus: true, ...options }
  );
}
